import { Input } from '@chakra-ui/react';
import {
  UpdateSupplierItemCodeRequest,
  ProductApproval,
  productApprovalsApi,
} from '@texas/api/endpoints/productApprovalsApi';
import { AutoUpdateResponseCallback } from '@texas/components/shared/autoUpdate/types';
import {
  AutoUpdateWrapper,
  useAutoUpdateForm,
} from '@texas/components/shared/autoUpdate/useAutoUpdateForm';
import { ErrorLabel } from '@texas/components/shared/ErrorLabel';
import { useTranslation } from 'react-i18next';

export function SupplierItemCodeInput({
  productApproval,
  onChanged,
}: {
  productApproval: ProductApproval;
  onChanged: (supplierItemCode: string) => void;
}) {
  const { t } = useTranslation();

  function onResponse(
    data: AutoUpdateResponseCallback<
      UpdateSupplierItemCodeRequest,
      UpdateSupplierItemCodeRequest
    >,
  ) {
    if (data.states.filter((f) => f.hasError).length > 0) return;
    onChanged(data.unmodifiedServerData.supplierItemCode);
  }

  const { registerAutoUpdate, form, formState, triggerSubmit, register } =
    useAutoUpdateForm<
      UpdateSupplierItemCodeRequest,
      UpdateSupplierItemCodeRequest
    >({
      defaultValue: {
        supplierItemCode: productApproval.externalSupplierItemCode,
      },
      requestParams: [productApproval.id],
      namePrefix: 'supplierItemCode',
      autoUpdateRequest: productApprovalsApi.autoUpdateExternalSupplierItemCode,
      onResponse,
    });

  return (
    <form {...form}>
      <AutoUpdateWrapper
        autoUpdateProps={registerAutoUpdate}
        path="supplierItemCode"
        boxProps={{ flexGrow: '1' }}
      >
        <Input
          textAlign="right"
          variant="texas"
          {...register('supplierItemCode', {
            onBlur: triggerSubmit,
            maxLength: {
              value: 20,
              message: t('errors.maxLength', { count: 20 }),
            },
          })}
          onKeyUp={(e) => {
            if (e.key === 'Enter') triggerSubmit();
          }}
        />
        <ErrorLabel text={formState.errors.supplierItemCode?.message} />
      </AutoUpdateWrapper>
    </form>
  );
}
